var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 174,
    height: 50,
    viewBox: "0 0 174 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M92.7398 17.1506L94.9943 7.10327H105.238L95.8275 41.9947H84.849L82.6925 31.6534C81.6811 26.7211 80.8969 22.4749 80.34 18.9105C79.7206 22.7645 78.9186 27.0152 77.9384 31.6534L75.7819 41.9947H64.8034L55.3933 7.10327H65.6366L67.8911 17.1506C69.3303 23.522 70.3105 28.178 70.8318 31.1187C71.5848 26.5473 72.4492 21.8913 73.4294 17.1506L75.4879 7.10327H85.1431L87.2015 17.1506C88.1818 21.8868 89.0461 26.5429 89.7991 31.1187C90.3561 28.178 91.3363 23.522 92.7398 17.1506Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M131.779 23.2769C133.575 23.9318 135.023 25.0413 136.115 26.6096C137.211 28.178 137.759 29.8755 137.759 31.7068C137.759 34.9727 136.654 37.5079 134.453 39.3035C132.247 41.0991 128.972 41.9991 124.628 41.9991H106.94V7.10767H124.29C128.536 7.10767 131.606 7.95868 133.504 9.65624C135.397 11.3538 136.346 13.4613 136.346 15.9787C136.346 19.4406 134.827 21.8778 131.788 23.2813L131.779 23.2769ZM123.595 14.7489H116.733V20.7283H123.595C124.838 20.8263 125.711 20.354 126.214 19.307C126.722 18.2599 126.722 17.2173 126.214 16.1703C125.706 15.1232 124.833 14.6509 123.595 14.7489ZM116.733 34.2999H124.085C126.437 34.2999 127.613 33.2395 127.613 31.1142C127.613 28.9889 126.437 27.9285 124.085 27.9285H116.733V34.2999Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M156.352 42.779C150.929 42.779 146.598 41.1304 143.364 37.8288C140.098 34.5629 138.463 30.1341 138.463 24.5468C138.463 18.9596 140.062 14.5174 143.266 11.2158C146.434 7.94989 150.796 6.3147 156.352 6.3147C160.825 6.3147 164.648 7.52215 167.82 9.94151C170.921 12.3921 172.802 15.7738 173.457 20.0868H163.556C163.097 18.3536 162.233 17.0258 160.959 16.0946C159.684 15.1634 158.147 14.7001 156.352 14.7001C153.834 14.7001 151.923 15.5511 150.617 17.2486C149.312 18.9462 148.657 21.3834 148.657 24.5513C148.657 27.7192 149.312 30.1564 150.617 31.8539C151.923 33.5515 153.834 34.4025 156.352 34.4025C158.312 34.4025 159.938 33.8723 161.226 32.8119C162.518 31.7515 163.342 30.2544 163.699 28.3296H173.501C172.944 32.9055 171.117 36.4476 168.012 38.965C164.875 41.5136 160.985 42.7879 156.347 42.7879L156.352 42.779Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4223 15.9478H33.57V33.1506H49.3382C49.8773 30.6288 50.06 27.9867 49.8506 25.2821C49.5877 21.9538 48.7456 18.8127 47.4223 15.9478Z",
    fill: "#1ED699"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3459 0.0859037C18.9869 0.192837 17.6547 0.3978 16.3671 0.691866V15.9521H47.4223C42.7484 5.81576 32.1264 -0.840852 20.3459 0.0859037Z",
    fill: "#1ED699"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.57 33.1506V15.9478H39.7009C44.9584 15.9478 49.4139 19.9444 49.8417 25.1841C49.8417 25.2153 49.8461 25.251 49.8506 25.2821C50.0645 27.9867 49.8773 30.6288 49.3382 33.1506H33.57Z",
    fill: "url(#paint0_linear_83_1103)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2.51481 33.155H16.3671V15.9521H0.598926C0.0598036 18.474 -0.122885 21.1161 0.0865261 23.8206C0.349404 27.1489 1.19151 30.2901 2.51481 33.155Z",
    fill: "#1ED699"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5911 49.0169C30.9501 48.9099 32.2823 48.705 33.5699 48.4109V33.1506H2.51471C7.18859 43.287 17.8106 49.9436 29.5911 49.0169Z",
    fill: "#1ED699"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2363 33.155C4.9787 33.155 0.523151 29.1584 0.0954174 23.9187C0.0954174 23.883 0.0909531 23.8518 0.0864976 23.8206C-0.127369 21.1161 0.0597751 18.474 0.598897 15.9521H16.3671V33.155H10.2363Z",
    fill: "url(#paint1_linear_83_1103)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_83_1103",
    x1: 41.7549,
    y1: 33.1506,
    x2: 41.7549,
    y2: 15.9478,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ED699"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#119364"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_83_1103",
    x1: 8.18225,
    y1: 33.155,
    x2: 8.18225,
    y2: 15.9521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#119364"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1ED699"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo-white.00bd5752b8a47f6a6a2d0d0fda5fa436.svg";
export { ForwardRef as ReactComponent };